import {RoleService} from "@/services/RoleService";

require('./bootstrap');
require('./plugins');
require('./axios-config')
import './registerServiceWorker';
import Vue from 'vue';
import * as axios from 'axios';

window.axios = axios;
window.Vue = Vue;

import Vuesax from 'vuesax'

Vue.use(Vuesax, {
  // options here
  // REGISTRO DE NUEVOS COLORES PARA USO GENERAL EN APP
  theme: {
    colors: {
      primary: '#008629',
      warning: '#f9a01b',
      secondary: '#CBFF00',
      dark: '#3b3a3e',
      success: '#46c93a',
      danger: '#ff4757',
    }
  }
})

import 'vuesax/dist/vuesax.css' //Vuesax style.envs

// ACL
import acl from './acl/acl'


if (process.env.VUE_APP_ENV === 'development') {
  Vue.config.devtools = true
  Vue.config.debug = true
}

window.op_data = process.env.VUE_APP_OPENPAY_ID;
window.op_public = process.env.VUE_APP_OPENPAY_API_KEY;
window.op_production = process.env.VUE_APP_OPENPAY_ENV === 'production';

Vue.config.errorHandler = (err, vm, info) => {
  console.error(err)
  // err: error trace
  // vm: component in which error occured
  // info: Vue specific error information such as lifecycle hooks, events etc.
};

import App from './views/App.vue'

import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard from './vx-components/vx-card/VxCard.vue'
import StatisticsCardLine from './vx-components/statistics-cards/StatisticsCardLine.vue'
import VxTimeline from './vx-components/timeline/VxTimeline.vue'
import VxList from './vx-components/vx-list/VxList.vue'
//import VxBreadcrumb  from '@/layouts/components/VxBreadcrumb.vue'
import FeatherIcon from './vx-components/FeatherIcon.vue'
import VxInputGroup from './vx-components/vx-input-group/VxInputGroup.vue'
import VxTextArea from './vx-components/vx-text-area/VxTextArea.vue'
import VxSelect from './vx-components/vx-select/VxSelect.vue'
import VxSelectItem from './vx-components/vx-select/VxSelectItem.vue'
import VError from './components/forms/VError.vue'
import DownloadButton from './components/projectsv2/DownloadButton.vue'
import vsSelect from './vx-components/vsSelect/vsSelect';
import vsSelectGroup from './vx-components/vsSelect/vsSelectGroup';
import vsSelectItem from './vx-components/vsSelect/vsSelectItem';
import VsCheckBox from './vx-components/vs-checkbox/VsCheckBox.vue'
import VsTable from './vx-components/vs-table/VsTable.vue';
import VueCountryCode from "vue-country-code-select";

import router from "./router";
import store from "./store";
import {mapState, mapMutations, mapActions} from "vuex";
import VeeValidate, {Validator} from 'vee-validate'
//import es from './vee-locale/es_custom'

import rgConsole from "./components/mixins/rgConsole";
import notifsHelper from "./components/mixins/notificationsHelper";
import publicApiHelper from "./helpers/publicApiHelper";

import 'vuesax/dist/vuesax.css' // Vuesax
//import 'material-icons/iconfont/material-icons.css' //Material Icons
import './assets/scss/app-supplier.scss'
import './assets/css/main.css'
import './assets/css/supplier-custom.css'
import './assets/css/backoffice.css'
import './assets/css/vuexy-alerts.css'
import './assets/css/document-upload.css'

// Feather font icon
require('./assets/css/iconfont.css')
import es from './vee-locale/es_custom'
//import * as Sentry from "@sentry/vue";
//import { BrowserTracing } from "@sentry/tracing";
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.use(VeeValidate);
Validator.localize('es', es);
Vue.mixin(rgConsole)
Vue.mixin(notifsHelper)
Vue.mixin(publicApiHelper)

// v-select component
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';
import {CrossSiteScripting} from "@/models/Security/CrossSiteScripting";
import SupplierRestrictedData from "./views/admin/suppliers/components/SupplierRestrictedData.vue";
import EmailableStatusComponent from "./components/projectsv2/components/EmailableStatusComponent.vue";

Vue.component(SupplierRestrictedData.name, SupplierRestrictedData);
Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(StatisticsCardLine.name, StatisticsCardLine)
Vue.component(VxTimeline.name, VxTimeline)
Vue.component(VxList.name, VxList)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(VxTextArea.name, VxTextArea)
Vue.component(VxSelect.name, VxSelect)
Vue.component(VxSelectItem.name, VxSelectItem)
Vue.component(VError.name, VError)
Vue.component(DownloadButton.name, DownloadButton)
Vue.component(vsSelect.name, vsSelect)
Vue.component(vsSelectGroup.name, vsSelectGroup)
Vue.component(vsSelectItem.name, vsSelectItem)
Vue.component(VsCheckBox.name, VsCheckBox)
Vue.component(VsTable.name, VsTable)
Vue.component(VueCountryCode.name, VueCountryCode)


// Components Root
Vue.component('formdata-file-upload', () => import('./views/admin/formdata-file-upload.vue'));
Vue.component('ajax-pagination', () => import('./views/admin/ajax-pagination'));
Vue.component('big-title', require('./components/projectsv2/BigTitle').default);
Vue.component('document-upload', require('./components/misc/DocumentUpload').default);
Vue.component('load-error', require('./components/misc/LoadError').default);
Vue.component('EmailableStatusComponent', EmailableStatusComponent);

Vue.prototype.$isLoading = false;
Vue.prototype.$sanitizeUrl = require("@braintree/sanitize-url").sanitizeUrl;
Vue.prototype.$sanitizeHtml = CrossSiteScripting.sanitize;

Vue.mixin({
    data: function () {
        return {
            get StorageURL() {
                return process.env.VUE_APP_STORAGE_DOMAIN;
            },
            get ApiGateway() {
                return process.env.VUE_API_GATEWAY;
            },
            get ApiDomain() {
                return process.env.VUE_APP_API_DOMAIN;
            },
            get ShowRGConsoleErrors() {
                return process.env.VUE_APP_SHOW_DEV_CONSOLE_WARNINGS === 'true';
            },
            get ShowRGConsoleWarns() {
                return process.env.VUE_APP_SHOW_DEV_CONSOLE_WARNINGS === 'true';
            },
            get ShowRGConsoleLogs() {
                return process.env.VUE_APP_SHOW_DEV_CONSOLE_WARNINGS === 'true';
            }
        }
    },
    computed: {
        ...mapState("auth", ["user"]),
        ...mapState("menu", ["rolesOfUser"]),
        AccessToken() {
            return this.user.access_token;
        },
        currentUser () {
            return this.user;
        },
        operatorUser() 
        {
            return 4830;
        }
    },
    methods: {
        canView(menuItem, extra = null) {
            if (menuItem.route.permissions) {
                const result = menuItem.route.permissions.filter((role) => {
                    return this.rolesOfUser.includes(role);
                })
                return result.length > 0;
            }
            return false;
        },
        hasRole(guardName) {
            if (this.user !== null) {
                const matches = this.user.user_roles.filter((role) => {
                    return role.guard_name === guardName;
                });

                return matches.length > 0;
            }
            return false;
        },
        showLoading(show, text = null) {
            if (show) {
                if (this.$isLoading) return;        
                this.$isLoading = true;
                this.$vs.loading(text ? { text } : undefined);
            } else {
                this.$isLoading = false;
                this.$vs.loading.close();
            }
        },
        startLoading() {
            this.$isLoading = true;
            this.$vs.loading();
        },
        stopLoading() {
            this.$isLoading = false;
            this.$vs.loading.close();
        },
    }
});
/*Sentry.init({
  Vue,
  dsn: "https://fd64577ffe82473d9595bff8440c4094@o4504403686588416.ingest.sentry.io/4505366538485760",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["redgirasol.com", /^\//],
    }),
  ],
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0,
});*/

new Vue({
    render: h => h(App),
    router,
    store,
    computed: {
        ...mapState("auth", ["user"])
    },
    watch: {
        user: async function (val) {
            let token = (val === null) ? '' : val.access_token;
            this.setAccessToken(token);
            await this.requireExchangeValues();
        }
    },
    beforeMount() {
        // ERROR permission or session interceptor
        axios.interceptors.response.use(response => {
            return response;
        }, (err) => {
            if (err.response.status) {
                if (err.response.status === 401) {
                    this.logout()
                    this.$router.push("/login")
                }
            }

            return Promise.reject(err);
        })
    },
    async mounted() {
      this.registryUniqueDeviceId()
        await this.$store.commit('menu/renderApp')
        this.$store.commit("auth/setRoleAvailable");

        if (this.user !== null) {
            this.setAccessToken(this.user.access_token);
            await this.requireExchangeValues();
        }
    },
    methods: {
      ...mapMutations('auth', ['logout']),
      ...mapActions('misc', ['requireExchangeValues']),
      registryUniqueDeviceId() {
        let deviceId = this.$cookies.get('device_id');
        if (deviceId === null) {
          deviceId = this.getRandomCrypto();
          deviceId = btoa(deviceId);
          this.$cookies.set('device_id', deviceId, '1y', null, process.env.VUE_APP_MICROFRONT_DOMAIN);
        }
      },
      getRandomCrypto() {
        const crypto = window.crypto || window.msCrypto;
        let array = new Uint32Array(1);
        let random = crypto.getRandomValues(array);

        return random[0] / 10000000000;
      },
      approveListModal(id) {
          this.$refs["approveListModalComp"].show(id)
      },
      setAccessToken(token) {
          window.axios.defaults.headers.common = {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Authorization': 'Bearer ' + token
          }
      }
    }
}).$mount('#app');
